export type Link = {
  color: string;
  href: string;
  label: string;
  /**
   * Marks a URL that identifies Rick himself, for the Person schema's sameAs.
   * Product pages, articles and reference links are deliberately not profiles.
   */
  profile?: boolean;
};

export const links: Link[] = [
  {
    color: "#66ff00",
    href: "https://www.f37.com",
    label: "Founder & Employer",
    profile: true,
  },
  {
    color: "#cc0099",
    href: "https://f37.com/fonts/f37-ginger",
    label: "Type Designer",
  },
  {
    color: "#ffff99",
    href: "https://antiaverage.studio",
    label: "Creative Director",
    profile: true,
  },
  {
    color: "#33ccff",
    href: "https://soundcloud.com/clubbed-events/rick-banks-clubbed-28-november-manchester-2025",
    label: "DJ",
  },
  {
    color: "#ff3333",
    href: "https://en.wikipedia.org/wiki/Obsessive%E2%80%93compulsive_personality_disorder",
    label: "Neurodiverse",
  },
  {
    color: "#6666ff",
    href: "https://antiaverage.studio/shop",
    label: "Publisher",
  },
  {
    color: "#ffffff",
    href: "https://www.madebydyslexia.org/",
    label: "Dyslexic Thinker",
  },
  {
    color: "#cc00ff",
    href: "https://antiaverage.studio/shop/football-type-2",
    label: "Author",
  },
  {
    color: "#ffcccc",
    href: "https://www.linkedin.com/in/rickbanksf37/",
    label: "Lecturer",
    profile: true,
  },
  {
    color: "#99ffff",
    href: "https://www.nhs.uk/mental-health/conditions/generalised-anxiety-disorder-gad/",
    label: "Anxious",
  },
  {
    color: "#ff6600",
    href: "https://media.tenor.com/7SHSlgSigMIAAAAd/ginger-souls.gif",
    label: "Ginger",
  },
  {
    color: "#000",
    href: "https://clubbed.events/",
    label: "Promotor",
    profile: true,
  },
  {
    color: "#99ff99",
    href: "https://www.theboltonnews.co.uk/news/11142832.author-rick-banks-and-former-bolton-wanderers-captain-kevin-davies-give-40000-to-improve-grass-roots-football-in-horwich/",
    label: "Philanthropist",
  },
  {
    color: "#ffff00",
    href: "https://www.dandad.org/creative-community/judges?initial=r&page=9&search=",
    label: "D&AD Judge",
  },
  {
    color: "#ff6666",
    href: "https://www.nhs.uk/mental-health/conditions/social-anxiety/",
    label: "Socially Phobic",
  },
  {
    color: "#c0c0c0",
    href: "https://www.creativereview.co.uk/",
    label: "Creative Review Judge",
  },
  {
    color: "#99ccff",
    href: "https://i2-prod.mirror.co.uk/article11587067.ece/ALTERNATES/s1200b/Billy-Joel-And-Peter-Kay-Perform-At-Croke-Park-In-Dublin1.jpg",
    label: "Northern",
  },
];
